import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import renderCheckBoxField from '../formFields/CheckBox';
import renderInputField from '../formFields/Input';
import { SIGNUP_PATH, RESET_PASSWORD_PATH } from '../../utils/constants';
import { validate } from '../../utils/form';

class LogInForm extends PureComponent {
  render() {
    const { handleSubmit, submitting, hasError, loggining } = this.props;
    return (
      <div className="auth-form login-form">
        <div className="error-wrapper">
          {hasError && (
            <Alert color="danger">
              Wrong email or password please try again
            </Alert>
          )}
        </div>
        <div className="form-title">Already a Start developer? Log in here</div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="email"
                component={renderInputField}
                type="text"
                placeholder="Email"
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="password"
                component={renderInputField}
                type="password"
                validateOn="blur"
                placeholder="Password"
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="remember_me"
                component={renderCheckBoxField}
                label="Remember me"
                className="colored"
              />
              <div className="account__forgot-password">
                <Link to={RESET_PASSWORD_PATH}>Forgot your password?</Link>
              </div>
            </div>
          </div>
          <div className="block-centered">
            <button
              className="btn btn-primary account__btn account__btn--small"
              disabled={loggining || submitting}
              onClick={handleSubmit}
            >
              Sign In
            </button>
          </div>
          <div className="full-width auth-link">
            New User? <Link to={SIGNUP_PATH}>Create account here</Link>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'LogInForm',
  validate
})(LogInForm);



// WEBPACK FOOTER //
// ./src/components/logIn/LogInForm.js